import request from '../utils/request';

export const fetchData = query => {
    return request({
        url: './lesson.json',
        method: 'get',
        params: query
    });
};
